export enum NewsroomUuid {
    NEWS = '97839360-72e0-4d2e-842b-79d320ad11a3',
    ACADEMY = '707d3332-28f8-4fca-b6e6-a6a5f7c17a4d',
    HELP = '9e0297b0-f37f-4492-a7c4-d98fffe86760',
    CHANGELOG = '583de002-99fc-4617-95e6-feb0e2f5091e',
}

export enum ContentType {
    FORM = 'form',
    PAGE = 'page',
    PREZLY_STORY = 'prezlyStory',
    CASE_STUDY = 'caseStudy',
    PRESS_RELEASE_EXAMPLE = 'pressReleaseExample',
    BLOCK_ANNOUNCEMENT = 'blockAnnouncement',
    BLOCK_CTA = 'blockCta',
    BLOCK_CUSTOM = 'blockCustom',
    BLOCK_QUOTE = 'blockQuote',
    BLOCK_COLLECTION = 'blockCollection',
    BLOCK_TOUT = 'blockTout',
}

// Hash modals should use `#:modalName-:parameters` hashes
export enum ModalName {
    WATCH_PRODUCT_VIDEO = 'watchProductVideo',
    VIDEO = 'video',
    MODAL_CLOSED = '_',
    APPLY_FOR_AGENCY = 'apply_for_agency',
    TALK_TO_SALES = 'talk_to_sales',
}
